module.exports = __webpack_public_path__ + "static/img/title_contact.2168dd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/title_contact.png
// module id = CnuK
// module chunks = 1